import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useUserMe } from "@/lib/user-me";
import { DeleteAccountDialog } from "@/components/v2/account/DeleteAccountDialog";
import { SettingsSection } from "@/components/v2/account/SettingsSection";

/**
 * `/account/danger-zone` — soft-delete the account. Owners with no
 * co-owners can't delete themselves; backend returns 409 and the
 * dialog surfaces it.
 */
export function AccountDangerZone() {
  const me = useUserMe();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <SettingsSection
      title="Delete account"
      description="Permanently disable your account. This soft-deletes your user — you can be restored within 30 days by contacting support."
      tone="danger"
    >
      <Button variant="destructive" onClick={() => setDialogOpen(true)}>
        Delete my account
      </Button>

      <DeleteAccountDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        email={me.data?.email ?? ""}
      />
    </SettingsSection>
  );
}
